import { IAgent } from "interfaces/entities/agent.interface";
import { Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface AgentCardProps {
  agent: IAgent;
}
export const AgentCard = ({ agent }: AgentCardProps) => {
  const navigate = useNavigate();
  return (
    <Card>
      <CardContent>
        <h5
          className="cursor-pointer"
          onClick={() => navigate(`/admin/ai-agents/${agent.id}/settings`)}
        >
          {agent.name}
        </h5>
        <Typography variant="body1">{agent.description}</Typography>
      </CardContent>
    </Card>
  );
};
